import { NavLink } from 'react-router-dom';
import { ActivityActionsProps } from '../types';
import { ActionMenuItem } from './ActionMenuItem';

export const CprActions = ({ activity }: ActivityActionsProps) => {
  const activitykeyUrlEncoded = encodeURIComponent(activity?.activitykey ?? 'null');

  return (
    <>
      <NavLink to={'/cpr/' + activitykeyUrlEncoded}>
        <ActionMenuItem icon={'view'} title={'View'} />
      </NavLink>
    </>
  );
};
